import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITipoTramiteCosto } from '../../shared/interfaces/database/liquidacion';

@Injectable({
  providedIn: 'root'
})
export class ConceptosImpuestosService {

  private readonly baseUrl = `${environment.apiUrl}/api/conceptos-impuestos`;

  constructor(private readonly http: HttpClient) { }

  getConceptoImpuestoCostos(tipoTramiteId: number): Observable<ITipoTramiteCosto[]> {
    return this.http.get<ITipoTramiteCosto[]>(`${this.baseUrl}/costos/${tipoTramiteId}`);
  }
}
